import PropTypes from "prop-types";
import styled from "styled-components";
import Text from './Text';

const Subtitle = styled(Text)`
  color: ${({ color, theme }) => theme.color[color]};
  font-size: ${ ({ size }) => size }px;
  line-height: ${ ({ size }) => size + 8 }px;
  letter-spacing: 2.17px;
  font-weight: ${({ weight }) => weight};
  text-transform: uppercase;
  font-family: 'Realtime Rounded', sans-serif;
  opacity: .3;
`;

Subtitle.propTypes = {
  as: PropTypes.oneOf(["h1", "h2", "h3", "h4", "h5", "h6"]).isRequired,
};

Subtitle.defaultProps = {
  as: "h4",
  color: "dark",
  size: 13,
  weight: "900"
};

export default Subtitle;
